// @flow

import * as React from 'react'

import { Button, Menu, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowDropDown as ArrowDropDownIcon } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  subheader: {
    opacity: '1 !important',
    color: theme.palette.primary.main,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
  button: {
    marginLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}))

type Props = {
  formsAppEnvironmentId: number,
  organisations: ExtendedOrganisation[],
  onSelectFormsAppEnvironment: (FormsAppEnvironment) => void,
}

function HeaderFormsAppEnvironmentsMenu({
  formsAppEnvironmentId,
  organisations,
  onSelectFormsAppEnvironment,
}) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const { organisation, formsAppEnvironment } = React.useMemo(() => {
    for (const organisation of organisations) {
      for (const formsAppEnvironment of organisation.formsAppEnvironments) {
        if (formsAppEnvironment.id === formsAppEnvironmentId) {
          return {
            organisation,
            formsAppEnvironment,
          }
        }
      }
    }
    return {}
  }, [formsAppEnvironmentId, organisations])

  const openMenu = React.useCallback(
    (event) => setAnchorEl(event.currentTarget),
    []
  )
  const closeMenu = React.useCallback(() => setAnchorEl(null), [])
  const handleClickMenuItem = React.useCallback(
    (formsAppEnvironment) => {
      closeMenu()
      onSelectFormsAppEnvironment(formsAppEnvironment)
    },
    [closeMenu, onSelectFormsAppEnvironment]
  )

  if (
    organisations.length === 1 &&
    organisations[0].formsAppEnvironments.length === 1
  ) {
    return null
  }

  return (
    <React.Fragment>
      <Button
        color="inherit"
        variant="outlined"
        onClick={openMenu}
        className={classes.button}
      >
        <>
          {organisation && formsAppEnvironment
            ? `${organisation.name} (${formsAppEnvironment.name})`
            : 'Select Environment'}
          <ArrowDropDownIcon />
        </>
      </Button>

      <Menu anchorEl={anchorEl} open={anchorEl !== null} onClose={closeMenu}>
        {organisations.map((organisation) => [
          <MenuItem
            key={organisation.id}
            disabled
            dense
            className={classes.subheader}
          >
            {organisation.name}
          </MenuItem>,
          ...organisation.formsAppEnvironments.map((formsAppEnvironment) => (
            <MenuItem
              key={formsAppEnvironment.id}
              selected={formsAppEnvironmentId === formsAppEnvironment.id}
              onClick={() => handleClickMenuItem(formsAppEnvironment)}
            >
              {formsAppEnvironment.name}
            </MenuItem>
          )),
        ])}
      </Menu>
    </React.Fragment>
  )
}

export default React.memo<Props>(HeaderFormsAppEnvironmentsMenu)
